// extracted by mini-css-extract-plugin
module.exports = {"clickableCard":"ClickableCard_clickableCard__2NaNf","activeKeypress":"ClickableCard_activeKeypress__PuJUi"};